import { LOGIN_POPUP_VISIBILITY, LOGIN_POPUP_HIDE_AND_CLEAR } from "./LoginPopupAction";

/**
 *
 * @param {*} state
 * @param {*} action
 * Reducer for login popup visibility
 *
 */
const initialState = {
  status: false,
  callbacks: [],
};
export default function LoginPopupReducer(state = initialState , action) {
  switch (action.type) {
    case LOGIN_POPUP_VISIBILITY :
      return {
        ...state,
        loginPopupVisibility: action.payload.status,
        callbacks: typeof action.payload.callback === 'function' ? [...state.callbacks, action.payload.callback] 
                                                                 :  state.callbacks 
      };
    case  LOGIN_POPUP_HIDE_AND_CLEAR :
      return initialState;
    default:
      return state;
  }
}
